import React from 'react';
const FILE_URL = 'https://drive.google.com/file/d/1aDiH8WLuLT03MaFrQtryuLg3oFhaSkAB/view?usp=sharing';
export function SecuenciaPage() {
  return <div className="min-h-screen bg-navy flex items-center justify-center px-6" data-id="element-226">
      <div className="max-w-md w-full text-center" data-id="element-227">
        <img src="https://cdn.magicpatterns.com/uploads/8iq9FdZPWhhg1moFGMfStg/Gemini_Generated_Image_vohteevohteevoht_(1)-Photoroom.png" alt="Oscar Rodriguez" className="w-32 mx-auto mb-8 object-contain" data-id="element-228" />

        <h1 className="text-3xl md:text-4xl font-serif text-white mb-4" data-id="element-229">
          Tu secuencia está lista
        </h1>

        <p className="text-gray-light text-lg mb-10" data-id="element-230">
          Haz clic en el botón para descargar tu guía.
        </p>

        <a href={FILE_URL} target="_blank" rel="noopener noreferrer" className="inline-block bg-gold hover:bg-yellow-500 text-navy font-bold text-lg px-8 py-4 rounded transition-all duration-300 hover:scale-105" data-id="element-231">
          Ver y descargar guía
        </a>

        <p className="text-gray-light/50 text-sm mt-8" data-id="element-232">
          © {new Date().getFullYear()} Oscar Rodríguez
        </p>
      </div>
    </div>;
}